

<div class="col-md-12 mb-30" [hidden]="Selected_CalibrationDelivery_Id!=-1" >
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات تحویل دستگاه ها</h5>
     <br/>
     <br>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری	</label>
          <input [(ngModel)]="Filter_customer"  name="Filter_customer" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

     <br/>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_CalibrationDelivery(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="OnSet_Selected_CalibrationDelivery_Id(0)" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <button *ngIf="Procssing" type="button"  class="btn btn-info" style="margin-left: 5px;"> لطفا صبر نمائید ...  <i class="fa fa-spin fa-spinner"></i> </button>
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>نام مشتری</th>
              <th>نوع تحویل</th>
              <th>تاریخ ثبت</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_CalibrationDelivery
            | paginate
                    : {
                        id: 'DataList_CalibrationDeliveryTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_CalibrationDelivery).length
                      }
            " [ngClass]="{'DownLoaded': item.status_lab===1,'Uploaded': item.status_lab===2,'Certificate': item.status_lab===3}">
             <td>{{DataList_CalibrationDelivery.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
              <td>{{item.customer_name}}</td>
              <td>{{item.inperson}} </td>
              <td>{{item.subdate}} </td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <!--
                          <a class="dropdown-item"  (click)="openModal_upload(templateUpload,item)" ><i class="fa fa-eye"></i> فایل ضمیمه </a>
                          <a class="dropdown-item" [routerLink]="['/CalibrationReceptionForm',{id:item.id}]"><i class="fa fa-edit"></i> ویرایش </a>
                        -->
                        <a style="cursor: pointer;" class="dropdown-item" (click)="OnSet_Selected_CalibrationDelivery_Item(item)"><i class="fa fa-eye"></i> مشاهده </a>
                        
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_CalibrationDeliveryTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<div *ngIf="Selected_CalibrationDelivery_Id==0">
  <app-CalibrationDeliveryForm>
  </app-CalibrationDeliveryForm>

  <button (click)="OnSet_Back_CalibrationDelivery_Id()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>
</div>


<div *ngIf="Selected_CalibrationDelivery_Id>0">
  <app-CalibrationDeliveryView
    [inner_Record]="Selected_DataList_CalibrationDelivery">
  </app-CalibrationDeliveryView>

  <button (click)="OnSet_Back_CalibrationDelivery_Id()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>
</div>